import { useCallback, useRef } from 'react';
export const useKeyboard = ({
  navigation
}) => {
  const sliderRef = useRef();
  const onKeydown = useCallback(({
    key
  }) => {
    switch (key) {
      case 'Left':
      case 'ArrowLeft':
        return sliderRef.current?.prev();
      case 'Right':
      case 'ArrowRight':
        return sliderRef.current?.next();
      default:
        return undefined;
    }
  }, []);
  const plugin = useCallback(slider => {
    sliderRef.current = slider;
    sliderRef.current.on('created', instance => {
      const {
        container
      } = instance;
      container.setAttribute('tabindex', '0');
      container.addEventListener('keydown', onKeydown);
    });
    sliderRef.current.on('destroyed', instance => {
      const {
        container
      } = instance;
      container.removeEventListener('keydown', onKeydown);
      sliderRef.current = undefined;
    });
  }, [onKeydown]);
  return navigation?.enableKeyboard === true ? plugin : undefined;
};
//# sourceMappingURL=useKeyboard.js.map